export const AUTH_TOKEN_KEY = 'auth_token';
export const USER_ROLE_KEY = 'user_role';
export const USER_MASTER_ID_KEY = 'user_master_id';

// Token functions
export const setToken = (token) => {
  sessionStorage.setItem(AUTH_TOKEN_KEY, token);
};

export const getToken = () => {
  return sessionStorage.getItem(AUTH_TOKEN_KEY);
};

// User role functions
export const setUserRole = (role) => {
  localStorage.setItem(USER_ROLE_KEY, role);
};

export const getUserRole = () => {
  return localStorage.getItem(USER_ROLE_KEY);
};

// User Master ID functions
export const setUserMasterId = (id) => {
  localStorage.setItem(USER_MASTER_ID_KEY, id);
};

export const getUserMasterId = () => {
  return localStorage.getItem(USER_MASTER_ID_KEY);
};

// Remove auth data
export const removeAuthData = () => {
  sessionStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(USER_ROLE_KEY);
  localStorage.removeItem(USER_MASTER_ID_KEY);
};

// Auth check functions
export const isAuthenticated = () => {
  return !!getToken();
};

export const isAdmin = () => {
  return getUserRole() === 'admin';
};

export const isUser = () => {
  return getUserRole() === 'user';
};


